import { render, staticRenderFns } from "./KPICards.vue?vue&type=template&id=28b1682e&scoped=true"
import script from "./KPICards.vue?vue&type=script&lang=js"
export * from "./KPICards.vue?vue&type=script&lang=js"
import style0 from "./KPICards.vue?vue&type=style&index=0&id=28b1682e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b1682e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28b1682e')) {
      api.createRecord('28b1682e', component.options)
    } else {
      api.reload('28b1682e', component.options)
    }
    module.hot.accept("./KPICards.vue?vue&type=template&id=28b1682e&scoped=true", function () {
      api.rerender('28b1682e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/dashboardSolicitudes/components/KPICards.vue"
export default component.exports